import { APP_COPY, getAppCopyForLocale, type AppCopy } from './appCopy';
import { getHistoryCopy as getHistoryCopyForLocale } from './historyCopy';
import { detectLocale, localeToBcp47, localeToHtmlLang, ENGLISH_UI_LABELS, type AppLocale } from './locale';
import { getTooltipCopy as resolveTooltipCopy } from './tooltipCopy';

export * from './locale';
export * from './appCopy';
export {
  clearSelectedCells,
  copySelectedCells,
  pasteSelectedCells,
  changePouchColor,
  changeGroupColor,
  enableMuteSymbol,
  doubleClickEditColumn,
  doubleClickToggleColumn,
  deleteClearColumn,
  enableBalancingToTotal,
  switchBalancingToTarget,
  countLegendLabel,
  commitValue,
  type TooltipCopy,
} from './tooltipCopy';
export {
  historyActionLabel,
  getHistoryStorageCopy,
  localizeHistoryDescription,
  HISTORY_STORAGE_LOCALE,
  type HistoryCopy,
} from './historyCopy';
export * from './colorCopy';
export * from './billing';
export { isPurchaseCancelledMessage, localizeEntitlementError } from './entitlementErrors';

let activeLocale: AppLocale = detectLocale();

export function setActiveLocale(locale: AppLocale): void {
  activeLocale = locale;
}

export function getActiveLocale(): AppLocale {
  return activeLocale;
}

export function getAppCopy(locale?: AppLocale): AppCopy {
  return getAppCopyForLocale(locale ?? activeLocale);
}

export function getTooltipCopy(locale?: AppLocale) {
  return resolveTooltipCopy(locale ?? activeLocale);
}

export function getHistoryCopy(locale?: AppLocale) {
  return getHistoryCopyForLocale(locale ?? activeLocale);
}

export { APP_COPY, localeToBcp47, localeToHtmlLang, ENGLISH_UI_LABELS };
